import React from 'react'

import clsx from 'clsx'

import Html from 'components/Html'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import classes from './Description.module.scss'

/** @type {import("./types").default} */
const Description = ({ listing, description, className }) => {
  const { addEvent } = useEventContext()

  const highlyViewedEventString = listing.most_visited ? ' | highly-viewed' : ''

  const listingDescription = description || (listing.description || '').replace(/\n/g, '<br />')

  return (
    <div data-testid="listing-item_description" className={clsx('Description', classes.root, className)}>
      <Html className={classes.description} Component="div">
        {listingDescription}
      </Html>
      <a
        className={classes.anchor}
        data-testid="listing-item_text-link_read-more-about-product"
        href={listing.cta_urls.detail}
        {...addEvent({
          engagementComponent: 'product_card-item',
          engagementDetails: `text-link_read-more-about-product${highlyViewedEventString}`,
          engagementDestination: 'go-to_product_details',
          name: 'engagement_product_click',
        })}
      >
        <Typography variant="button-md">
          <Html>{`Read more about ${listing.name}`}</Html>
        </Typography>
      </a>
    </div>
  )
}

export default Description
